import { ErrorHandler, inject, Injectable } from '@angular/core';

import { UiToastService } from '../ui/toast/toast.service';
import { ZipyService } from '../tracking/zipy.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly toast = inject(UiToastService);
  private readonly zipy = inject(ZipyService);

  handleError(error: unknown): void {
    this.zipy.logError(error);

    const message = error instanceof Error ? error.message : 'An unexpected error occurred.';
    this.toast.show({ tone: 'error', message });

    console.error('[GlobalErrorHandler]', error);
  }
}
